<template>
    <div></div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    methods:{
    },
    created() {
        window.location.href = "https://www.legalbytez.com/"
    },
}
</script>